module.exports = __webpack_public_path__ + "media/V101.431980f3.mp4";